export default "__VITE_ASSET__FA9cDdro__"